import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { getFolders } from "../../context/fetch/fetchTemplates";
import { useTemplatesValue } from "../../context/reducers/templatesContext";
import LeftSide from "./LeftSide";
import RightSide from "./RightSide";
import {
  getTemplatesSuccess,
  getFoldersSuccess,
  attemptGetFolders,
} from "../../context/actions/templatesActions";
import useDebouncedSearch from "../../hooks/useDebouncedSearch";
import SearchInput from "../../core/SearchInput";

const Main = (props) => {
  const [state, dispatch] = useTemplatesValue();

  const initialState = useMemo(() => {
    return {
      columnName: "createdAt",
      sortAsc: true,
    };
  }, []);
  const [sortQuery, setSortValue] = useState(initialState);
  const { searchQuery, debouncedSearch, handleSearchChange, resetSearch } = useDebouncedSearch();

  const { showInModal } = props;

  useEffect(() => {
    let didCancel = false;

    const fetchFolders = async () => {
      dispatch(attemptGetFolders());

      try {
        const sort = `${sortQuery.columnName}:${sortQuery.sortAsc ? "asc" : "desc"}`;

        const result = await getFolders(showInModal, sort, debouncedSearch);

        const { folders, activeFolderId, templates } = result;
        if (activeFolderId) {
          !didCancel && dispatch(getTemplatesSuccess({ templates, id: activeFolderId }));
        }
        !didCancel && dispatch(getFoldersSuccess({ folders, activeFolderId }));
      } catch (error) {}
    };
    fetchFolders();
    return () => (didCancel = true);
  }, [dispatch, showInModal, sortQuery, debouncedSearch]);

  return (
    <>
      <Container className={"info-container"}>
        <Row className={"justify-content-start"}>
          <Col md={10} lg={8} className={"info-section assets-section"}>
            {!props.showInModal && (
              <div className="info-card">
                <p className={"info-title text-uppercase fbold"}>Create New Template</p>
                <p className={"info-text"}>
                  Create your individual mobile screen with the ayscan template creator for any
                  images or pages you want to link with digital content.
                </p>
                <ul className="info-steps">
                  <li>Add folder and subfolder with +</li>
                  <li>Add new template</li>
                  <li>Choose elements, drag and drop to the view on the left side</li>
                  <li>If you like to use the same header and footer for multiple images or pages, fill out header and footer with logo, texts, social media icons</li>
                  <li>If you like to change header and footer for each image or page, leave it blank</li>
                </ul>
              </div>
            )}
          </Col>
        </Row>
      </Container>
      <Container className={"editor-container"}>
        <div className="d-flex justify-content-end mb-3">
          <SearchInput
            value={searchQuery}
            onChange={handleSearchChange}
            onClear={resetSearch}
            placeholder="Search templates..."
          />
        </div>
        <div className={"overview-editor templates-view"}>
          <Row className={"justify-content-start"}>
            <Col>
              <div className={"editor-view assets-view"}>
                <Row className={"justify-content-start"}>
                  <Col col={12}>
                    <div className={"file-editor"}>
                      <div
                        className={`align-items-stretch d-flex flex-column flex-lg-row h-100 ${
                          state.folder.template.isTmplsLoading ? "eventDisabled" : ""
                        }`}
                      >
                        <LeftSide {...props} sortQuery={sortQuery} debouncedSearch={debouncedSearch} />
                        <RightSide
                          sortQuery={sortQuery}
                          setSortValue={setSortValue}
                          searchQuery={searchQuery}
                          handleSearchChange={handleSearchChange}
                          resetSearch={resetSearch}
                          {...props}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default Main;
